import gql from "graphql-tag";

/**
 * @param {string} authId
 * @param {string} email
 * @param {string} name
 */
export const INSERT_TEAM_AND_USER = gql`
  mutation createNewTeamAndUser(
    $authId: String!
    $email: String!
    $name: String
  ) {
    __typename
    insert_team(
      objects: {
        users_by_teamId: {
          data: { authId: $authId, email: $email, name: $name }
        }
      }
    ) {
      returning {
        id
        users_by_teamId {
          id
          email
          authId
          name
        }
      }
    }
  }
`;
